import { CancelTokenSource } from 'axios';
import {
  DistributeQuantityRequest,
  DistributeQuantityResponse,
  EmergencyDataRequest,
  EmergencyDataResponse,
  EntryResponse,
  PatientEntryRequest,
  QuantityValidationRequestDto,
  QuantityValidationResponseDto,
  TarmedDataDto,
  UpdateTarmedEntryDataRequest
} from 'ts-types/api.types';
import axios from './http';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;

export const updateTarmedEntriesWithEmergencyData = (emergencyDataRequest: EmergencyDataRequest, source: CancelTokenSource): Promise<EmergencyDataResponse> => {
  return axios
      .post(`${baseUrl}/api/update-emergency-data`, emergencyDataRequest, { cancelToken: source.token })
      .then(response => response.data);
};

export const updateTarmedEntrySubPriceAndBastardData = (updateTarmedEntryDataRequest: UpdateTarmedEntryDataRequest, source: CancelTokenSource): Promise<TarmedDataDto> => {
  return axios
      .post(`${baseUrl}/api/update-tarmed-entry-data`, updateTarmedEntryDataRequest, { cancelToken: source.token })
      .then(response => response.data);
};

export const generateEntries = (
    entryRequest: PatientEntryRequest, source: CancelTokenSource): Promise<EntryResponse> => {

  return axios
      .post(`${baseUrl}/api/generate-entries`, entryRequest, {cancelToken: source.token})
      .then(response => response.data);
};

export const distributeBulkQuantities = (distributeQuantityRequest: DistributeQuantityRequest, source:CancelTokenSource): Promise<DistributeQuantityResponse> => {
  return axios
      .post(`${baseUrl}/api/distribute-bulk-quantities`, distributeQuantityRequest, {cancelToken: source.token})
      .then(response => response.data);
};

export const validateTarmedQuantity = (quantityValidationRequest: QuantityValidationRequestDto, source: CancelTokenSource): Promise<Array<QuantityValidationResponseDto>> => {
  return axios
      .post(`${baseUrl}/api/validate-tarmed-quantity`, quantityValidationRequest, {cancelToken: source.token})
      .then(response => response.data)
};
